/** JSON with object keys sorted, so equal values serialise identically. */
export const canonicalTemplateJson = (value: unknown): string =>
  JSON.stringify(value, (_, entry: unknown) =>
    entry && typeof entry === 'object' && !Array.isArray(entry)
      ? Object.fromEntries(Object.entries(entry).sort(([a], [b]) => a.localeCompare(b)))
      : entry
  );
